'use strict'

var all = require('../all')
var wrapped = require('../util/wrap-children')
var base = require('./base')
var blockquote = require('./blockquote')
var br = require('./break')
var cell = require('./table-cell')
var code = require('./code')
var comment = require('./comment')
var dataList = require('./data-list')
var del = require('./delete')
var emphasis = require('./emphasis')
var heading = require('./heading')
var image = require('./image')
var inlineCode = require('./inline-code')
var link = require('./link')
var list = require('./list')
var listItem = require('./list-item')
var media = require('./media')
var paragraph = require('./paragraph')
var quote = require('./q')
var root = require('./root')
var row = require('./table-row')
var strong = require('./strong')
var table = require('./table')
var text = require('./text')
var thematicBreak = require('./thematic-break')
var wbr = require('./wbr')

exports.root = root
exports.text = text
exports.comment = comment
exports.doctype = ignore

exports.applet = ignore
exports.area = ignore
exports.basefont = ignore
exports.bgsound = ignore
exports.caption = ignore
exports.col = ignore
exports.colgroup = ignore
exports.command = ignore
exports.content = ignore
exports.datalist = ignore
exports.dialog = ignore
exports.element = ignore
exports.embed = ignore
exports.input = ignore
exports.isindex = ignore
exports.keygen = ignore
exports.link = ignore
exports.map = ignore
exports.math = ignore
exports.menu = ignore
exports.menuitem = ignore
exports.meta = ignore
exports.nextid = ignore
exports.noscript = ignore
exports.object = ignore
exports.optgroup = ignore
exports.option = ignore
exports.param = ignore
exports.script = ignore
exports.select = ignore
exports.shadow = ignore
exports.source = ignore
exports.spacer = ignore
exports.style = ignore
exports.svg = ignore
exports.template = ignore
exports.title = ignore
exports.track = ignore

exports.abbr = all
exports.acronym = all
exports.bdi = all
exports.bdo = all
exports.big = all
exports.blink = all
exports.canvas = all
exports.cite = all
exports.data = all
exports.details = all
exports.dfn = all
exports.font = all
exports.marquee = all
exports.meter = all
exports.nobr = all
exports.output = all
exports.progress = all
exports.slot = all
exports.small = all
exports.span = all
exports.sup = all
exports.sub = all
exports.tbody = all
exports.tfoot = all
exports.thead = all
exports.time = all

exports.address = wrapped
exports.article = wrapped
exports.aside = wrapped
exports.body = wrapped
exports.center = wrapped
exports.div = wrapped
exports.figcaption = wrapped
exports.figure = wrapped
exports.footer = wrapped
exports.header = wrapped
exports.hgroup = wrapped
exports.html = wrapped
exports.main = wrapped
exports.multicol = wrapped
exports.nav = wrapped
exports.picture = wrapped
exports.section = wrapped

exports.a = link
exports.audio = media
exports.b = strong
exports.base = base
exports.blockquote = blockquote
exports.br = br
exports.code = inlineCode
exports.dir = list
exports.dl = dataList
exports.dt = listItem
exports.dd = listItem
exports.del = del
exports.em = emphasis
exports.h1 = heading
exports.h2 = heading
exports.h3 = heading
exports.h4 = heading
exports.h5 = heading
exports.h6 = heading
exports.hr = thematicBreak
exports.i = emphasis
exports.img = image
exports.image = image
exports.kbd = inlineCode
exports.li = listItem
exports.listing = code
exports.mark = emphasis
exports.ol = list
exports.p = paragraph
exports.plaintext = code
exports.pre = code
exports.q = quote
exports.s = del
exports.samp = inlineCode
exports.strike = del
exports.strong = strong
exports.summary = paragraph
exports.table = table
exports.td = cell
exports.th = cell
exports.tr = row
exports.tt = inlineCode
exports.u = emphasis
exports.ul = list
exports.var = inlineCode
exports.video = media
exports.wbr = wbr
exports.xmp = code

function ignore() {}
